import React from 'react'
import styled from 'styled-components'
import { withPrefix } from 'gatsby-link'

const SVG = styled.svg`
  width: 2rem;
  height: 1rem;
  color: #000;
  &.ppm-icon {
    &.2 {
      width: 3rem;
      height: 2rem;
    }
    &.3 {
      width: 4rem;
      height: 3rem;
    }
    &.4 {
      width: 6rem;
      height: 4rem;
    }
  }
`

const Icon = props => {
  let { name, size, className } = props

  let useTag = `<use xlink:href='${withPrefix(
    `/icons.svg#${name}`
  )}' href='${withPrefix(`/icons.svg#${name}`)}' />`

  return (
    <SVG
      {...props}
      className={`ppm-icon ${size} ${className}`}
      dangerouslySetInnerHTML={{ __html: useTag }}
    />
  )
}
export default Icon



// WEBPACK FOOTER //
// ./src/components/icon/icon.js